import { render, staticRenderFns } from "./PsiSidebarNavigation.vue?vue&type=template&id=2edd539a&scoped=true&"
import script from "./PsiSidebarNavigation.vue?vue&type=script&lang=js&"
export * from "./PsiSidebarNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd539a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VNavigationDrawer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2edd539a')) {
      api.createRecord('2edd539a', component.options)
    } else {
      api.reload('2edd539a', component.options)
    }
    module.hot.accept("./PsiSidebarNavigation.vue?vue&type=template&id=2edd539a&scoped=true&", function () {
      api.rerender('2edd539a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/navigation/PsiSidebarNavigation.vue"
export default component.exports